module.exports = __webpack_public_path__ + "img/android.08495199.svg";